// /* global kakao */
import React, { useEffect } from 'react';

const JungjinMap = () => {

  useEffect(() => {
    // 1. kakao API 존재 여부 확인
    if (window.kakao && window.kakao.maps) {

      // 2. 스크립트 로드 완료 후 실행되도록 load 콜백 적용
      window.kakao.maps.load(() => {
        var container = document.getElementById('map');

        var options = {
          center: new window.kakao.maps.LatLng(35.9019704, 128.587826),
          level: 1
        };

        var map = new window.kakao.maps.Map(container, options);
        var markerPosition = new window.kakao.maps.LatLng(35.9019704, 128.587826);

        var marker = new window.kakao.maps.Marker({
          position: markerPosition
        });

        marker.setMap(map);
      });
    }
  }, []);

  return (
    <>
      <div>
        <h3 style={{ textAlign: 'center', color: 'darkBlue', backgroundColor: 'lightgray' }}>
          1공장:정진피엔지 [아연피막,칼슘피막,착색,에칭]
        </h3>
        <div>
          <div id="map" style={{ width: "100%", height: "70vh" }}></div>
        </div>
        &nbsp;
        <h5 style={{ textAlign: 'center' }}>주소 : 대구시 북구 침산동 67길7 (침산동)</h5>
      </div>
    </>
  );
};

export default JungjinMap;